/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export const fileDataTypesMapUI: { [key: string]: string } = {
	NUMERIC: 'number',
	DATE: 'date',
	DATETIME: 'datetime',
	TIME12: 'time12',
	TIME24: 'time24',
	CHAR: 'text',
	IMAGE: 'image'
};

export enum FileDataTypesMapSort {
	NUMERIC = 'number',
	DATE = 'string',
	DATETIME = 'string',
	CHAR = 'string'
}

export enum YesNoEnum {
	Yes = 'Y',
	No = 'N'
}

export const fileBooleanMappings: { [key: string]: boolean } = {
	Y: true,
	N: false
};

// ToDo: extract in functions
export const fileBooleanToString = (fileBoolean: boolean): string => (fileBoolean ? 'Y' : 'N');
